import {Routes} from '@angular/router';
import {DashboardContentComponent} from './dashboard-content/dashboard-content.component';
import {DashboardFilterComponent} from './dashboard-filter/dashboard-filter.component';
import {PbiPlaygroundComponent} from './pbi-playground/pbi-playground.component';
import {ItcdAnalyticsComponent} from './itcd-analytics/itcd-analytics.component';
import {AnalyticsV2Component} from './analytics-v2/analytics-v2.component';
import {Dac6AnalyticsV2Component} from './dac6-analytics-v2/dac6-analytics-v2.component';
import {PowerSearchDashboardV2Component} from './power-search-dashboard-v2/power-search-dashboard-v2.component';
import {PowerSearchContentv2Component} from './power-search-contentv2/power-search-contentv2.component';
import {OicAnalyticsComponent} from '@features/dashboard/oic-analytics/oic-analytics.component';
import {FormsDownloadComponent} from '@features/dashboard/forms-download/forms-download.component';
import {ItpDesktopLauncherComponent} from '@features/itp-desktop/components/itp-desktop-launcher/itp-desktop-launcher.component';
import {PlatformLinkCreatorComponent} from "@shared/components/platform-tool/platform-link-creator/platform-link-creator.component";
import {
  PlatformRightSidebarV2Component
} from "@shared/components/platform-sidebar/components/platform-right-sidebar-v2/platform-right-sidebar-v2.component";
import {HomeGuard} from '@core/services/home.guard';

/**
 * Created by hsmasud on 4/3/2019.
 */
export const dashboardRoutes: Routes = [
  {
    path: '',
    component: PlatformLinkCreatorComponent,
    canActivate: [HomeGuard],
  },
  {
    path: 'filter',
    component: DashboardFilterComponent
  },
  {
    path: 'analytics',
    component: AnalyticsV2Component
  },
/*  {
    path: 'analyticsV1',
    component: AnalyticsComponent
  },*/
  {
    path: 'analytics/playground',
    component: PbiPlaygroundComponent
  },
  /*{
    path: 'dac6-reporter/dac6-analyticsV1',
    component: Dac6AnalyticsComponent
  },*/
  {
    path: 'analytics/playground',
    component: PbiPlaygroundComponent
  },
  {
    path: 'dashboard-content/:tabId',
    component: DashboardContentComponent
  },
  {
    path: 'dashboard-content',
    component: DashboardContentComponent
  },
  {
    path: 'itcd/analytics',
    component: ItcdAnalyticsComponent
  },
  {
    path: 'home',
    component: PlatformLinkCreatorComponent,
    canActivate: [HomeGuard],
  },
  // {
  //   path: 'oic/dashboard',
  //   component: OicAnalyticsComponent
  // },
/*
  {
    path: 'homev1',
    component: PowerSearchDashboardComponent
  },
*/
  {
    path: 'home/:groupId/:tabId',
    component: PowerSearchContentv2Component
  },
  {
    path: 'platform-right-sidebar-v2',
    component: PlatformRightSidebarV2Component
  },
  {
    path : 'forms-download/:formId',
    component : FormsDownloadComponent
  },
  {
    path     : 'dashboard/gmt',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'platform-workflow',
    component: PlatformLinkCreatorComponent
  }
  // {
  //   path      : 'itp-desktop',
  //   component: PlatformLinkCreatorComponent
  // }
  /*,
  {
    path: 'homev1/:groupId/:tabId',
    component: PowerSearchContentComponent
  }*/
];
